import { useNavigate } from 'react-router-dom';

import { Button, Group, Text } from '@mantine/core';

import { Show } from '@clerk/react';

import { WAITLIST_MODE } from '@/config/featureFlags';

export function HeaderLinks() {
  const navigate = useNavigate();
  return (
    <Group gap="sm">
      {['About', 'Pricing', 'FAQ'].map((item) => (
        <Text
          key={item}
          size="sm"
          fw={500}
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(`/${item.toLowerCase()}`)}
        >
          {item}
        </Text>
      ))}
      {!WAITLIST_MODE && (
        <Show when="signed-out">
          <Button variant="filled" size="xs" onClick={() => navigate('/signin')}>
            Sign In
          </Button>
        </Show>
      )}
      <Show when="signed-in">
        <Button variant="filled" size="xs" onClick={() => navigate('/app')}>
          Go to App
        </Button>
      </Show>
    </Group>
  );
}
